/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
// Costanti condivise del widget "Dettatura SOAP" (lingue, sezioni, preferenza lingua).
export const LANG_OPTIONS = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹', shortLabel: 'IT' },
  { code: 'en', label: 'English', flag: '🇬🇧', shortLabel: 'EN' },
  { code: 'es', label: 'Español', flag: '🇪🇸', shortLabel: 'ES' },
  { code: 'auto', label: 'Auto-rileva', flag: '🌐', shortLabel: 'AUTO' },
];

// Preferenza UI non sensibile (lingua di dettatura) — vedi CODE_QUALITY_NOTES.md §2.5
export const STORAGE_KEY = 'sanitanexus.soap.lang';

export const readSavedLang = () => {
  try {
    const v = typeof window !== 'undefined' ? window.localStorage?.getItem(STORAGE_KEY) : null;
    if (v && LANG_OPTIONS.some((o) => o.code === v)) return v;
  } catch (e) { /* ignore */ }
  return 'it';
};

export const SECTION_LABELS = {
  subjective: { label: 'Soggettivo', color: 'bg-blue-500/10 text-blue-700 dark:text-blue-300' },
  objective: { label: 'Obiettivo', color: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300' },
  assessment: { label: 'Diagnosi', color: 'bg-amber-500/10 text-amber-700 dark:text-amber-300' },
  plan: { label: 'Piano', color: 'bg-purple-500/10 text-purple-700 dark:text-purple-300' },
};
